import { jsxs as l, jsx as v } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M44 12V6h-4v6H24V6h-4v6H10c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h48V12H44Zm-34 4h10v4l4-1.08V16h16v4l4-1.08V16h10v7H10v-7Zm0 32V25h44v23H10Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          d: "M17.9 30h-4v4h4v-4ZM25.95 30h-4v4h4v-4ZM34 30h-4v4h4v-4ZM42.05 30h-4v4h4v-4ZM50.1 30h-4v4h4v-4ZM17.9 37.97h-4v4h4v-4ZM25.95 37.97h-4v4h4v-4ZM34 37.97h-4v4h4v-4ZM42.05 37.97h-4v4h4v-4ZM50.1 37.97h-4v4h4v-4Z"
        }
      )
    ]
  }
);
export {
  o as Calendar
};
